import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  FormControl,
  Alert,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useAxios } from "../../hooks/useAxios";
import { ApiResponse } from "../../models/ApiResponse";
import { CallItem, emptyCallItem } from "../../models/ServiceCall";

// temporary added by alvin
import divisionData from "../../data/mappingData.json";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

let callItemModalOpen = (
  item: CallItem,
  contract: boolean,
  division: number
) => {};
let callItemModalClose = () => {};

type CallItemDialogProps = {
  onClose?: () => void;
};

// added by alvin
interface ItemObject{
  id: number;
  name: string;
  mapping: string;
}

interface CategoryObject{
  id: number;
  name: string;
  items: ItemObject[];
}

export default function CustomizedDialogs({ onClose }: CallItemDialogProps) {
  const [open, setOpen] = React.useState(false);
  const [contract, setContract] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [isAdd, setIsAdd] = React.useState(false);
  const [item, setItem] = React.useState<CallItem>(emptyCallItem(""));
  const axios = useAxios();
  // added by alvin
  const [selectedDivisionId, setSelectedDivisionId] = React.useState("");
  const [selectedDivisionCategories, setselectedDivisionCategories] = React.useState<CategoryObject[]>([]);
  const [selectedCategoryItems, setselectedCategoryItems] = React.useState<ItemObject[]>([]);

  // modified by alvin: added division as new parameter
  callItemModalOpen = (item: CallItem, contract: boolean, division: any) => {
    setIsAdd(item.id === undefined || item.id === "");
    setItem(item);
    setOpen(true);
    setContract(contract);
    setSelectedDivisionId(division);
  };

  callItemModalClose = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  // Added by alvin: to set/populate the category and item variables from the filtered data objects.
  React.useEffect(() => {
    // Find the selected division based on its ID
    console.log("Division ID : " + selectedDivisionId);
    const selectedDivisionObject = divisionData.divisions.find(obj => obj.id === parseInt(selectedDivisionId));
    if (selectedDivisionObject) {
        setselectedDivisionCategories(selectedDivisionObject.categories);
    }

    if(!isAdd){
      const selectedCategoryObject = divisionData.divisions.find((division) => division.id === parseInt(selectedDivisionId))?.categories.find((category) => category.id === item.category_id)
      if (selectedCategoryObject) {
          setselectedCategoryItems(selectedCategoryObject.items);
      } else {
        console.log('Object Not loaded...');
      }
    }

  }, [selectedDivisionId]);

  // Added by alvin - Handle Category data object on change
  const handleCategoryChange = (event: { target: { value: any; }; }) => {
    const selectedCategoryValue = event.target.value;
    const selectedCategoryObject = selectedDivisionCategories.find(cat => cat.id === selectedCategoryValue);
    if (selectedCategoryObject) {
        setselectedCategoryItems(selectedCategoryObject.items);
    }
    setItem((i) => ({...i,category_id: selectedCategoryValue as number, item_id: "",mapping: ""}));
    console.log("Category ID : " + selectedCategoryValue);
  };

  // Added by alvin - Handle Item data object on change
  const handleItemChange = (event: { target: { value: any; }; }) => {
      const selectedItemValue = event.target.value;
      const selectedItemObject = selectedCategoryItems.find(item => item.id === selectedItemValue);
      console.log("Item ID : " + selectedItemValue);
      setItem((i) => ({...i,item_id: selectedItemValue as number}));
      if (selectedItemObject){
          Object.keys(selectedItemObject).forEach(key => {
              if (key === "mapping") {
                  const selectedMapping = selectedItemObject[key] as string;
                  console.log("Mapping : " + selectedMapping);
                  setItem((i) => ({...i,mapping: selectedMapping}));
                }
          });
      }
  };  

 
    return (
    <div>
      <BootstrapDialog
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            return false;
          }
        }}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "800px", // Set your width here
            },
          },
        }}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={callItemModalClose}
        >
          {isAdd ? "Add" : "Edit"} Call Item
        </BootstrapDialogTitle>
        <DialogContent dividers>
          {contract && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              This machine is <b>Under Contract!</b> Please take this into
              consideration when costing items
            </Alert>
          )}
          <Grid container spacing={2}>
            <Grid item sm={12}>
              <FormControl sx={{ width: "100%" }} size="medium">
                <InputLabel id="divcat">Category</InputLabel>
                <Select
                  labelId="divcat"
                  label="Category"
                  value={item.category_id}
                  className="form-select mb-2"
                  fullWidth
                  onChange={handleCategoryChange}
                >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {selectedDivisionCategories.map(cat => (
                      <MenuItem key={cat.id} value={cat.id}>{cat.name}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item sm={12}>
              <FormControl sx={{ width: "100%" }} size="medium">
                <InputLabel id="catitem">Item</InputLabel>
                <Select
                  labelId="catitem"
                  label="Item"
                  value={item.item_id}
                  className="form-select mb-2"
                  fullWidth
                  onChange={handleItemChange}
                >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {selectedCategoryItems.map(item => (
                        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                    ))}                    
                </Select>
              </FormControl>
            </Grid>

            <Grid item sm={12}>
              <TextField
                fullWidth
                label="QTY"
                value={item.quantity}
                type="number"
                InputProps={{
                  inputProps: {
                    min: 1,
                    step: 0.01,
                  },
                }}
                onChange={(e) => {
                  setItem({
                    ...item,
                    quantity:
                      Math.round(
                        (parseFloat(e.target.value) + Number.EPSILON) * 100
                      ) / 100,
                  });
                }}
              />
            </Grid>
            <Grid item sm={12}>
              <TextField
                fullWidth
                label="Price"
                value={item.amount}
                type="number"
                InputProps={{
                  inputProps: {
                    min: 1,
                    step: 0.01,
                  },
                }}
                onChange={(e) => {
                  setItem({
                    ...item,
                    amount:
                      Math.round(
                        (parseFloat(e.target.value) + Number.EPSILON) * 100
                      ) / 100,
                  });
                }}
              />
            </Grid>
            <Grid item sm={12}>
              <TextField
                fullWidth
                label="Description"
                value={item.description}
                onChange={(e) => {
                  setItem({
                    ...item,
                    description: e.target.value,
                  });
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={loading}
            onClick={() => {
              
              console.log('Category ID: ' + item.category_id + " Item ID: " + item.item_id + " Mapping: " + item.mapping );
              if (contract) {
                // eslint-disable-next-line no-restricted-globals
                if (!confirm('Reminder: This machine is under contract. Did you check the costs?')) {
                  return
                }
              }

              setLoading(true);
              
              axios
                .post<ApiResponse<CallItem[]>>(
                  "callitem/addorupdate",
                  JSON.stringify(item)
                )
                .then((res) => {
                  const data = res.data;
                  alert(data.success ? "Item saved!" : "An error occurred");
                })
                .finally(() => {
                  setLoading(false);
                  callItemModalClose();
                });
            }}
          >
            Save changes
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}

export { callItemModalClose, callItemModalOpen };
